import { Col, Row } from "react-bootstrap";
import make from "../../Assets/Certs/make.png";
import aidev from "../../Assets/Certs/aidev.png";
import webdev from "../../Assets/Certs/webdev.png";
import aimanage from "../../Assets/Certs/aimanage.png";
import cloud from "../../Assets/Certs/cloud.png";

function CertificateCard() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons">
        <a href="https://www.credly.com/badges/dbbeaea3-7534-4c05-9738-f636ca89ef54" target="_blank" rel="noreferrer">
          <img src={make} style={{width: "40%"}}/>
        </a>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <a href="https://www.credly.com/badges/88926779-dd59-4db7-a135-5f54dba42526" target="_blank" rel="noreferrer">
          <img src={aimanage} style={{width: "40%"}}/>
        </a>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <a href="https://www.credly.com/badges/552709ee-5ec4-4d26-b134-91678f04e9f0" target="_blank" rel="noreferrer">
          <img src={webdev} style={{width: "40%"}}/>
        </a>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <a href="https://www.credly.com/badges/7c5ae2d5-f8ce-4778-8a47-1a8c1a2a424a" target="_blank" rel="noreferrer">
          <img src={aidev} style={{width: "40%"}}/>
        </a>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <a href="https://www.credly.com/badges/e27240ed-e535-4d02-b49c-2ed812ab9c84" target="_blank" rel="noreferrer">
          <img src={cloud} style={{width: "40%"}}/>
        </a>
      </Col>
    </Row>
  );
}

export default CertificateCard;
